import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.055 6.73c-.584-.325-1.297-.304-1.925.092l-4.464 3.345V8.333c0-.666-.362-1.28-.944-1.603-.584-.325-1.298-.304-1.925.092l-4.464 3.345V2.833a.916.916 0 1 0 0-1.833H1.917a.916.916 0 1 0 0 1.833v15.583A4.59 4.59 0 0 0 6.5 23h11.916A4.59 4.59 0 0 0 23 18.416V8.333c0-.666-.363-1.28-.945-1.603m-.889 11.686a2.753 2.753 0 0 1-2.75 2.75H6.5a2.753 2.753 0 0 1-2.75-2.75V2.833H6.5V17.5a.916.916 0 1 0 1.833 0v-5.042l5.5-4.125V12a.918.918 0 0 0 1.467.734l5.866-4.4zm-7.333-1.833v.917c0 .506-.41.916-.917.916H12a.917.917 0 0 1-.917-.916v-.917c0-.506.41-.917.917-.917h.916c.506 0 .917.411.917.917m1.833.917v-.917c0-.506.411-.917.917-.917h.917c.506 0 .916.411.916.917v.917c0 .506-.41.916-.916.916h-.917a.917.917 0 0 1-.917-.916"
    }, null, -1)
  ]))]))
}
export default { render: render }